import React from "react";

import FounderCommunityPage from "@/containers/CommunityJoiningPages/FounderCommunityPage";

import { renderMetaData } from "@/utils";

const FounderCommunity = () => {
  const metaData = {
    siteName: "Shyft",
    siteURL: "https://www.betheshyft.com/foundercommunity",
    title: "Health focused community only for Founders | Shyft",
    description:
      "Join a peer group of founders, super focused on helping keep the health & well-being in check during a super busy work-life.",
    thumbnail:
      "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2023-06/founder-community-thumbnail-ad506917620d4ea09f787ca7d817045b.jpg",
  };

  const metaTags = renderMetaData(metaData);

  return (
    <>
      {metaTags}
      <FounderCommunityPage />
    </>
  );
};

export default FounderCommunity;
